module.exports = __webpack_public_path__ + "img/login-art-13.e6bd56c.jpg";